<template>
  <div
    class="container lms-wrapper no-right-sidebar pd-x-0 pd-lg-x-10 pd-xl-x-0"
  >
    <div class="lms-sidebar">
      <div class="lms-sidebar-body">
        <vue-custom-scrollbar :style="`height: ${scrollHeight.nav}px`">
          <div :class="`card ${$store.state.app.isMobile ? 'bd-0' : ''}`">
            <div class="card-body">
              <student-nav @route-changed="toggleNavbar(false)"></student-nav>
            </div>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div>
    <div class="lms-content">
      <div class="lms-content-body">
        <div class="row">
          <div class="col-lg-12 col-xl-12 pd-t-0" style="padding-top: 0px">
            <template v-if="ftchd">
              <embed
                v-if="file.rdy"
                :src="file.link"
                :style="`width: 100%; height:${scrollHeight.content}px`"
              />
              <div v-else class="p-xl text-center">
                <div role="alert" class="alert alert-warning mg-b-0">
                  <h6 class="alert-heading">Мэдэгдэл</h6>
                  <hr />
                  <p class="mb-0">Танд одоогоор батламж үүсээгүй байна.</p>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";
import { request } from "@/api/all";

export default {
  components: {
    vueCustomScrollbar,
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    filePreview: () => ({
      component: import("@/components/modules/media/previewPage.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {
    return {
      scrollHeight: {
        contentToolbarHeight: 49,
        nav: 0,
        content: 0,
        right: 0
      },
      nowDate: null,
      allCount: 0,
      groupLogo: "",
      file: {
        rdy: false,
        link: ""
      },
      ftchd: false
    };
  },
  mounted() {
    this.toggleBodyClass("addClass", "app-lms");
    require("@/assets/css/dynamic.lms.css");

    window.addEventListener("resize", this.getWindowHeight);
    this.getWindowHeight();
    let _companyLogo = this.$store.state.app.groupSettings.filter(
      x => x.key == "companyLogo"
    );
    if (_companyLogo.length > 0 && _companyLogo[0].value != undefined) {
      this.groupLogo = _companyLogo[0].value;
    }
    this.init();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowHeight);
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  destroyed() {
    window.removeEventListener("resize", this.getWindowHeight);
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    init() {
      request({
        api: { method: "get", url: "learn/GetMyTmzCert" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.ftchd = true;
          if (res.data.fillForm) {
            this.$router.push({
              name: "lmsSurvey",
              params: { id: res.data.formId, name: "Судалгаа" }
            });
          } else {
            request({
              api: { method: "get", url: "Media/FileInheritedDetail" },
              params: { id: res.data.cert.defaultAttachmentId },
              store: this.$store
            }).then(res => {
              if (res != false) {
                this.file.link = res.data.file.link;
                this.file.rdy = true;
              }
            });
          }
          //FileInheritedDetail({ id: res.data.cert.defaultAttachmentId })
        }
      });
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
    },
    getWindowHeight() {
      let contentSub = 50;
      let navSub = 120;
      let rightSub = 120;
      if (screen.width <= 1024) {
        contentSub = 50;
        navSub = 85;
        rightSub = 85;
      }

      contentSub += this.scrollHeight.contentToolbarHeight;
      rightSub += this.scrollHeight.contentToolbarHeight;

      this.scrollHeight.content = window.innerHeight - contentSub;
      this.scrollHeight.nav = window.innerHeight - navSub;
      this.scrollHeight.right = window.innerHeight - rightSub;
    }
  }
  //   watch: {
  //     "$root.$route"(newRoute, oldRoute) {
  //       if (newRoute.params.cid != oldRoute.params.cid) {
  //         this.$nextTick(() => {
  //           this.init();
  //         });
  //       }
  //     }
  //   }
};
</script>
